import React from 'react';
import { ArrowRight, Shield, Award, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.querySelector('#servicii')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="acasa" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900"></div>
        {/* Logo watermark */}
        <div 
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage: `url(${companyInfo.logo})`,
            backgroundSize: '600px',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        ></div>
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-slate-900/40"></div>
        {/* Decorative elements */}
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-blue-500/20 rounded-full blur-[100px]"></div>
        <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-cyan-500/20 rounded-full blur-[100px]"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 pt-32 pb-20 relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-cyan-400 text-sm font-medium mb-8 animate-fade-in-up">
            <Shield size={16} />
            <span>Protecție garantată pentru construcția ta</span>
          </div>

          {/* Main heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-fade-in-up animation-delay-100">
            Hidroizolații Profesionale
            <span className="block text-gradient mt-2">în Iași și Împrejurimi</span>
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-slate-300 max-w-2xl mb-10 leading-relaxed animate-fade-in-up animation-delay-200">
            {companyInfo.description} Cu experiență și materiale de calitate superioară, 
            asigurăm protecția durabilă a clădirii dumneavoastră.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16 animate-fade-in-up animation-delay-300">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="btn-primary text-white px-8 py-6 text-lg rounded-full font-semibold group"
            >
              Solicită Ofertă Gratuită
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button
              onClick={scrollToServices}
              variant="outline"
              size="lg"
              className="border-2 border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg rounded-full font-semibold"
            >
              Vezi Serviciile Noastre
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-10 animate-fade-in-up animation-delay-400">
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-2">
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center">
                  <Clock className="text-cyan-400" size={24} />
                </div>
                <span className="text-3xl md:text-4xl font-bold text-white">{companyInfo.yearsExperience}+</span>
              </div>
              <p className="text-slate-400 text-sm">Ani de experiență</p>
            </div>
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-2">
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center">
                  <Award className="text-cyan-400" size={24} />
                </div>
                <span className="text-3xl md:text-4xl font-bold text-white">370+</span>
              </div>
              <p className="text-slate-400 text-sm">Proiecte finalizate</p>
            </div>
            <div className="text-center md:text-left col-span-2 md:col-span-1">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-2">
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center">
                  <Shield className="text-cyan-400" size={24} />
                </div>
                <span className="text-3xl md:text-4xl font-bold text-white">10+</span>
              </div>
              <p className="text-slate-400 text-sm">Ani garanție</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/60 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
